import React from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { useFormContext } from 'react-hook-form'
import { Form, FormHiddenText, FormPasswordValidate } from '../../../../shared/form/form'
import { useApiFormAuthPasswordRecover } from '../../../../api-new/state/auth'
import { useLoad } from '../../../../shared/hooks/load'
import { AuthHead, AuthPage } from '../../../../shared/sso-workspace/auth-card'

// /auth/password-recover/reset/:resetToken: choose the new password. The
// strength meter and rules are the shared FormPasswordValidate's.
export const PasswordReset = () => {
  const history = useHistory()
  const { resetToken } = useParams()

  const apiFormAuthPasswordRecover = useApiFormAuthPasswordRecover()

  useLoad(() => apiFormAuthPasswordRecover.init(), [])

  const handleSubmit = async data => {
    await apiFormAuthPasswordRecover.put(`${resetToken}`, data)
    history.replace('/auth/email')
  }

  const handleCancel = () => history.replace('/auth/email')

  return (
    <AuthPage labelledBy="password-reset-title">
      <AuthHead id="password-reset-title" title="Choose a new password" lede="Use at least 8 characters, with no spaces." />
      <Form onSubmit={handleSubmit}>
        <FormHiddenText name="resetToken" value={resetToken} />
        <FormPasswordValidate name="password" label="New password" required autoFocus />
        <ResetActions onCancel={handleCancel} />
      </Form>
    </AuthPage>
  )
}

const ResetActions = ({ onCancel }) => {
  const { formState } = useFormContext()
  const blocked = !formState.isDirty || Object.keys(formState.errors).length > 0 || formState.isSubmitting

  return (
    <div className="sa-actions mt-3">
      <button type="submit" className="btn sw-btn-primary sa-block" disabled={blocked}>
        {formState.isSubmitting ? 'Saving…' : 'Save password'}
      </button>
      <button type="button" className="btn sw-btn sa-block" onClick={onCancel}>Cancel</button>
    </div>
  )
}
